module.exports = __webpack_public_path__ + "img/main1.a82a8f01.png";